



























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { GrowthProfileController } from '@/services/request.service'
import moment from 'moment'
import { setToken, setSchoolInfo } from '@/utils/utils'

// 类型定义
interface GrowthProfile {
  name: string
  avatarUrl: string
  studentEnName: string
  studentName: string
  className: string
  schoolYearName: string
  totalPages: number
  port: number
  comments?: string
  gradeReportTraceMonthList: MonthGroup[]
  reports: Report[]
}

interface MonthGroup {
  month: string
  gradeReportTraces: Moment[]
}

interface Moment {
  traceId: string
  holdTime: string
  content: string
  traceResources: Resource[]
}

interface Resource {
  resourceId: string
  resourceType: string
  resourceUrl: string
}

interface Report {
  reportId: string
  period: string
  kindergarten: boolean
  firstClasses: SkillClass[]
  secondClasses: SkillClass[]
  finalGradingLevels: FinalLevel[]
  finalGradingClasses: FinalGradingClass[]
}

interface SkillClass {
  classId: string
  gradeClassName: string
  previousPosition: number
  currentPosition: number
}

interface FinalLevel {
  gradeFinalLevelId: string
  name: string
}

interface FinalGradingClass {
  classId: string
  name: string
  finalLevelId: string
}

@Component
export default class GrowthProfileViewer extends Vue {
  private get growthProfileId(): number {
    return parseInt(this.$route.params.growthProfileId, 10)
  }

  private get token() {
    return this.$route.params.token
  }
  private profile: any = {}
  private thNum: any = 9 // 技能等级数量

  // 日期时间格式化
  private formatDateTime(date: string): string {
    return moment(date).format('YYYY-MM-DD HH:mm')
  }

  // 生成二维码地址
  private generateQrCode(url: string): string {
    return `/api/pdf/qr?ori=${encodeURIComponent(url)}`
  }

  // 获取表头颜色
  private headerColor(level: number): string {
    const colors =
      this.thNum === 3
        ? ['rgb(227,74,9)', 'rgb(38,137,49)', 'rgb(29,82,168)']
        : [
            '#f4bd96',
            '#eb9153',
            '#ea7d32',
            '#a0fac7',
            '#46d686',
            '#10b559',
            '#a5d1f4',
            '#77baf1',
            '#3692dd',
          ]
    return `background-color: ${colors[level - 1]}`
  }

  // 获取技能状态图标
  private getStatusIcon(skill: SkillClass, level: number): string {
    const baseUrl = 'https://njstatic.dipont.com/enseed/static/images/'
    if (skill.previousPosition === level && skill.currentPosition !== level) {
      return `${baseUrl}prev.png`
    }
    if (skill.currentPosition === level && skill.previousPosition !== level) {
      return `${baseUrl}current.png`
    }
    if (skill.previousPosition === level && skill.currentPosition === level) {
      return `${baseUrl}half.png`
    }
    return ''
  }

  private created(): void {
    // setToken(this.token, true)
    this.getPortfolioInfo()
  }

  private getPortfolioInfo() {
    GrowthProfileController.detailForPdf(this.growthProfileId, this.token)
      .then(res => {
        this.profile = res.data
        if (this.profile.schoolYearId >= 165) {
          this.thNum = 3 // 新学年起技能等级数量调整为3
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
}
